import { render, staticRenderFns } from "./ProductsCompanyInfo.vue?vue&type=template&id=1a32cd25&scoped=true&"
import script from "./ProductsCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./ProductsCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCompanyInfo.vue?vue&type=style&index=0&id=1a32cd25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a32cd25",
  null
  
)

export default component.exports